(function () {
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  // Montant rond sans centimes : « 50 € »
  function formatSeuil(cents) {
    if (cents % 100 === 0) return (cents / 100) + ' €';
    return formatMoney(cents);
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function renderWidget(widgetEl, cart) {
    const thresholdAttr = widgetEl.getAttribute('data-threshold-cents');
    const threshold = parseInt(thresholdAttr, 10) || 5000;

    const textEl = widgetEl.querySelector('.free-shipping__text');
    const barEl  = widgetEl.querySelector('.free-shipping__bar');
    const fillEl = widgetEl.querySelector('.free-shipping__fill');
    if (!textEl || !barEl || !fillEl) return;

    const total = cart.total_price || 0;
    const items = cart.item_count || 0;
    const progress = Math.max(0, Math.min(1, total / threshold));

    fillEl.style.width = (progress * 100).toFixed(2) + '%';
    barEl.setAttribute('aria-valuenow', Math.round(progress * 100));

    if (!items || !total) {
      widgetEl.classList.remove('free-shipping--success');
      textEl.innerHTML = `Livraison standard offerte dès <strong>${formatSeuil(threshold)}</strong>.`;
    } else if (total < threshold) {
      widgetEl.classList.remove('free-shipping--success');
      const remaining = threshold - total;
      textEl.innerHTML = `Plus que <strong>${formatMoney(remaining)}</strong> pour la livraison standard offerte.`;
    } else {
      widgetEl.classList.add('free-shipping--success');
      textEl.textContent = 'Bravo ! La livraison standard vous est offerte.';
    }
  }

  // Lot L10 : heure du dernier affichage fait avec le panier renvoyé par le thème (voir plus bas)
  let derniereMaj = 0;

  async function updateAll() {
    const widgets = document.querySelectorAll('#free-shipping'); // supporte 1 ou plusieurs
    if (!widgets.length) return;
    const depart = Date.now();
    try {
      const cart = await getCart();
      if (depart < derniereMaj) return; // un affichage plus récent est déjà en place
      widgets.forEach(w => renderWidget(w, cart));
    } catch (e) {
      console.warn('[free-shipping] update failed', e);
    }
  }

  // Lot L10 : le message change en même temps que le total (même panier que celui renvoyé au thème après la modification)
  function brancherPanier() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cart = event && event.cartData;
      if (cart && typeof cart.total_price === 'number' && typeof cart.item_count === 'number') {
        derniereMaj = Date.now();
        document.querySelectorAll('#free-shipping').forEach(w => renderWidget(w, cart));
      } else {
        updateAll();
      }
    });
    return true;
  }
  if (!brancherPanier()) document.addEventListener('DOMContentLoaded', brancherPanier);

  // --- Init immédiat (au cas où DOMContentLoaded est déjà passé)
  updateAll();

  // --- Événements Shopify courants
  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('cart:updated', updateAll);
  document.addEventListener('cart:change', updateAll);
  document.addEventListener('cart:refresh', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('shopify:section:reorder', updateAll);
  document.addEventListener('shopify:section:unload', updateAll);

  // Quantités & formulaires
  document.addEventListener('change', (e) => {
    if (e.target.closest('.quantity, .quantity-selector, .quantity__input')) updateAll();
  });
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.matches('form[action*="/cart"], form[action*="/cart/add"], form[action*="/cart/change"]')) {
      setTimeout(updateAll, 400);
    }
  });

  // Filet de sécurité : mise à jour douce toutes les 3s si rien n’émet
  setInterval(updateAll, 3000);
})();
